<main class="site-shell" [class.mobile-route-shell]="isMobileRoute()" [attr.lang]="language()" aria-labelledby="bgi-title">
  @if (!isMobileRoute()) {
    <header class="site-header" [attr.lang]="language()">
      <a class="brand-left" href="/" aria-label="BG Imports home">
        <img
          class="brand-mark"
          src="screen_logo.png"
          alt="BG Imports logo"
          width="160"
          height="72"
        />
      </a>

      <div class="header-right" [attr.lang]="language()">
        <nav class="auth-links" aria-label="Authentication links">
          <a class="contact-pricing-link" [href]="'tel:' + phoneHref">{{ t('contactPricing') }}</a>
          <a routerLink="/mobile/login">{{ t('signIn') }}</a>
        </nav>

        <div class="lang-menu" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="lang-icon-btn"
            [attr.aria-label]="t('language')"
            aria-haspopup="menu"
            [attr.aria-expanded]="languageMenuOpen()"
            (click)="toggleLanguageMenu()"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm7.9 9h-3.1a15.6 15.6 0 0 0-1.5-5A8.03 8.03 0 0 1 19.9 11ZM12 4.05c1.1 1.2 2.18 3.55 2.7 6.95H9.3c.52-3.4 1.6-5.75 2.7-6.95ZM8.7 6a15.6 15.6 0 0 0-1.5 5H4.1A8.03 8.03 0 0 1 8.7 6ZM4.1 13h3.1a15.6 15.6 0 0 0 1.5 5A8.03 8.03 0 0 1 4.1 13Zm7.9 6.95c-1.1-1.2-2.18-3.55-2.7-6.95h5.4c-.52 3.4-1.6 5.75-2.7 6.95ZM15.3 18a15.6 15.6 0 0 0 1.5-5h3.1a8.03 8.03 0 0 1-4.6 5Z"/>
            </svg>
          </button>

          @if (languageMenuOpen()) {
            <div class="lang-popup" role="menu" [attr.aria-label]="t('language')">
              <button type="button" class="lang-option" [class.active]="language() === 'nl'" (click)="setLanguage('nl')">
                Nederlands
              </button>
              <button type="button" class="lang-option" [class.active]="language() === 'en'" (click)="setLanguage('en')">
                English
              </button>
              <button type="button" class="lang-option" [class.active]="language() === 'fr'" (click)="setLanguage('fr')">
                Francais
              </button>
            </div>
          }
        </div>
      </div>
    </header>
  }

  <section class="content-panel" [attr.lang]="language()" aria-label="Products experience">
    <router-outlet></router-outlet>
  </section>

  @if (!isMobileRoute()) {
    <footer class="site-footer" [attr.aria-label]="t('companyInfo')" [attr.lang]="language()">
      <div class="footer-main">
        <div class="footer-brand-block">
          <h2>{{ companyName }}</h2>
          <p>{{ t('companyInfo') }}</p>
        </div>

        <div class="footer-grid">
          <p class="footer-item"><strong>{{ t('vatLabel') }}</strong> {{ vatNumber }}</p>
          <p class="footer-item"><strong>{{ t('addressLabel') }}</strong> {{ address }}</p>
          <p class="footer-item"><strong>{{ t('phoneLabel') }}</strong> <a [href]="'tel:' + phoneHref">{{ phoneDisplay }}</a></p>
          <p class="footer-item"><strong>{{ t('emailLabel') }}</strong> <a [href]="'mailto:' + email">{{ email }}</a></p>
        </div>
      </div>

      <div class="footer-bottom">
        <small>&copy; {{ companyName }}. All rights reserved.</small>
      </div>
    </footer>
  }
</main>
